module.exports = __webpack_public_path__ + "static/media/clipboard-check-solid.5a2613fd.svg";